import { Link } from "react-router-dom";
import { Reveal } from "../Motion";

const LADDER = [
  { label: "THE ARTIST", value: "Motion & Meaning", to: "/artist" },
  { label: "THE PROJECT", value: "Multidimensional", to: "/#dimensions" },
  { label: "THE CURRENT CHAPTER", value: "Dimension I — I AM", to: "/dimension-i" },
];

export default function Manifesto() {
  return (
    <section className="relative py-32 md:py-48 bg-[#050505]" data-testid="manifesto">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-1">
            <Reveal>
              <span className="font-mono text-[11px] tracking-[0.3em] text-gold">I</span>
            </Reveal>
          </div>
          <div className="md:col-span-11 max-w-4xl">
            <Reveal>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.02] font-light text-white">
                Not everything exists<br />in <span className="italic text-gold">one dimension.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-12 text-lg md:text-xl leading-relaxed text-white/60 max-w-2xl">
                Motion &amp; Meaning is the artist. <span className="text-white/85">Multidimensional</span> is
                the universe — an unfolding series of Dimensions, each a chapter with its own sound,
                symbol and identity. What you are hearing now is only the first coordinate.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-10 max-w-3xl" data-testid="brand-hierarchy">
                {LADDER.map((step) => (
                  <Link key={step.label} to={step.to} className="group border-t border-white/10 pt-5 block">
                    <p className="font-mono text-[10px] tracking-[0.3em] text-white/40 mb-3">{step.label}</p>
                    <p className="font-serif text-xl md:text-2xl font-light text-white/85 group-hover:text-gold transition-colors duration-300">
                      {step.value}
                    </p>
                  </Link>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
